import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

export interface PaymentLogger {
    info: (message: string, payload?: Record<string, unknown>) => void;
    warn: (message: string, payload?: Record<string, unknown>) => void;
    error: (message: string, payload?: Record<string, unknown>) => void;
}

export const createPaymentLogger = ({
    data,
    prefix = "PaymentLogger:",
}: {
    data?: Record<string, unknown>;
    prefix?: string;
}): PaymentLogger => {
    const basePayload = {
        tag: LogTag.CHECKOUT,
    };

    return {
        info: (message: string, payload?: Record<string, unknown>) => {
            Logger.info(ServiceType.ADYEN, `${prefix} ${message}`, {
                ...basePayload,
                ...data,
                ...payload,
            });
        },
        warn: (message: string, payload?: Record<string, unknown>) => {
            Logger.warn(ServiceType.ADYEN, `${prefix} ${message}`, {
                ...basePayload,
                ...data,
                ...payload,
            });
        },
        error: (message: string, payload?: Record<string, unknown>) => {
            Logger.error(ServiceType.ADYEN, `${prefix} ${message}`, {
                ...basePayload,
                ...data,
                ...payload,
            });
        },
    };
};
